export const routes = (prefix) => [
    {
        path: `/${prefix}/users`,
        name: `${prefix}.users.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.users.index`,
                PageDescription: "User Listing/Create",
            },
        }
    },
];
